import { Controller } from "@hotwired/stimulus"

/**
 * Leaderboard Expand Controller
 *
 * Controls the visibility of rows 11-30 in the global leaderboard table.
 * Shows top 10 by default, with a "Show top 30" button to expand.
 * Uses the same slide animation as competition sections via CSS grid-template-rows.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["overflow", "inner", "button", "icon", "text"]

  declare readonly overflowTarget: HTMLElement
  declare readonly innerTarget: HTMLElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly iconTarget: SVGElement
  declare readonly textTarget: HTMLElement
  declare readonly hasOverflowTarget: boolean
  declare readonly hasInnerTarget: boolean

  private expanded = false

  toggle(): void {
    this.expanded = !this.expanded

    if (this.hasOverflowTarget) {
      this.overflowTarget.classList.toggle(
        "competition-overflow--expanded",
        this.expanded
      )
    }

    if (this.hasInnerTarget) {
      this.innerTarget.inert = !this.expanded
    }

    this.buttonTarget.setAttribute("aria-expanded", String(this.expanded))

    this.textTarget.textContent = this.expanded ? "Show less" : "Show more"

    this.iconTarget.style.transform = this.expanded ? "rotate(180deg)" : ""
  }
}
